import { render, staticRenderFns } from "./AgentNoticeManagement.vue?vue&type=template&id=21eef753&scoped=true"
import script from "./AgentNoticeManagement.vue?vue&type=script&lang=js"
export * from "./AgentNoticeManagement.vue?vue&type=script&lang=js"
import style0 from "./AgentNoticeManagement.vue?vue&type=style&index=0&id=21eef753&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21eef753",
  null
  
)

export default component.exports